/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';


export interface DssModelExport { 
    parameterData: Array<ParameterData>;
    schedules: Array<Schedule>;
    vhfBeaconFrequencies: Array<string>;
    dropOffType?: DssModelExport.DropOffTypeEnum;
    internalDropOffParameterData?: Array<ParameterData>;
    externalDropOffParameterData?: Array<ParameterData>;
}
export namespace DssModelExport {
    export const DropOffTypeEnum = {
        Internal: 'INTERNAL',
        External: 'EXTERNAL',
        Both: 'BOTH'
    } as const;
    export type DropOffTypeEnum = typeof DropOffTypeEnum[keyof typeof DropOffTypeEnum];
}


export type DropOffTypeEnum = typeof DssModelExport.DropOffTypeEnum[keyof typeof DssModelExport.DropOffTypeEnum];
